export enum ValidationGroupEnum {
  SalaryDividend = 'SALARY_DIVIDEND',
  IncomeTaxCorporation = 'INCOME_TAX_CORPORATION',
  IncomeTaxCorporationFederal = 'INCOME_TAX_CORPORATION_FEDERAL',
  Rrsp = 'RRSP'
}